import VBox from '@voly/ui-components/src/v2/VBox.jsx';
import VMenu from '@voly/ui-components/src/v2/VMenu.jsx';
import VMenuItem from '@voly/ui-components/src/v2/VMenuItem.jsx';
import VTooltip from '@voly/ui-components/src/v2/VTooltip.jsx';
import { ReactElement } from 'react';
import { translate } from 'src/app/project/features/translate/translate';
import { EFloatingActionsOptions } from 'src/app/project/modules/site/site-options/site-options-more-floating-actions/floating-actions-options.const';
import BulkActionButton from './BulkActionButton';

export type TBulkEditMenuProps = {
  options: EFloatingActionsOptions[];
  disabledReasons: Partial<Record<EFloatingActionsOptions, string>>;
  onSelect: (option: EFloatingActionsOptions) => void;
};

const OPTION_LABEL_KEYS: Record<EFloatingActionsOptions, string> = {
  [EFloatingActionsOptions.FLAG]: 'flags',
  [EFloatingActionsOptions.PRIORITY]: 'priority',
  [EFloatingActionsOptions.STATUS]: 'status',
  [EFloatingActionsOptions.CUSTOM_FIELDS]: 'custom_fields',
  [EFloatingActionsOptions.TAGS]: 'tags',
  [EFloatingActionsOptions.ASSIGNEES]: 'assignees',
};

const MENU_POSITIONING = { placement: 'top' };

const isBulkEditOption = (value: string): value is EFloatingActionsOptions =>
  value in OPTION_LABEL_KEYS;

const renderOption = (
  option: EFloatingActionsOptions,
  disabledReason: string | undefined,
): ReactElement => {
  const label = translate(OPTION_LABEL_KEYS[option]);

  if (disabledReason) {
    return (
      <VMenuItem key={option} value={option} disabled padding="0">
        <VTooltip content={disabledReason}>
          <VBox width="full" paddingX="2" paddingY="1.5">
            {label}
          </VBox>
        </VTooltip>
      </VMenuItem>
    );
  }

  return (
    <VMenuItem key={option} value={option}>
      {label}
    </VMenuItem>
  );
};

const BulkEditMenu = ({ options, disabledReasons, onSelect }: TBulkEditMenuProps): ReactElement => {
  const handleSelect = ({ value }: { value: string }): void => {
    if (isBulkEditOption(value)) {
      onSelect(value);
    }
  };

  return (
    <VMenu
      positioning={MENU_POSITIONING}
      onSelect={handleSelect}
      children={undefined}
      trigger={<BulkActionButton icon="edit" label={translate('edit')} />}
      items={options.map((option) => renderOption(option, disabledReasons[option]))}
    />
  );
};

export default BulkEditMenu;
